import { FormattedMessage } from 'react-intl';

import { Schema } from 'src/utils/form';

export default Schema.object({
  dataPeriodo: Schema.string().label(<FormattedMessage id="periodo" />),
  status: Schema.string().label(<FormattedMessage id="status" />),
  item: Schema.string().label(<FormattedMessage id="item" />),
});
